'use strict';

require('./packages/custom/inspinia/public/assets/css/inspinia.css');
require('./packages/custom/general-tasks/public/assets/css/general-tasks.css');
import 'angular/angular-csp.css';
import 'angular-ui-select/select.min.css';
import 'angular-material/angular-material.min.css';

import jQuery from 'jquery';
import 'bootstrap';
import 'angular';
import 'angular-ui-select/select';
import 'angular-mocks';
import 'angular-cookies';
import 'angular-resource';
import 'angular-sanitize';
import 'angular-ui-router';
import 'angular-jwt';
import 'angular-aria';
import 'angular-animate';
//import spin from 'spin.js';
import 'angular-loading';
import 'angular-material';
//import 'moment';
import 'angular-moment';
import 'angucomplete-alt';
import 'angularjs-toaster';
import 'angular-chart';
import 'summernote';
import 'pdfmake';
//import ngTable from 'ng-table/bundles/ng-table';
//import ngTableParams from 'ng-table';
import 'angular-ui-bootstrap';
import 'angular-moment-picker';

//require('imports?this=>window!angular');

//import 'ngDialog';
require('imports?this=>window!ng-dialog');
require('imports?this=>window!pdfmake/build/vfs_fonts.js');
var _ = require('lodash');

window.$ = jQuery;
window._ = _;

angular.element(document).ready(function () {
  // Fixing facebook bug with redirect
  if (window.location.hash === '#_=_') {
    window.location.hash = '#!';
  }

  // Then init the app
  angular.bootstrap(document, ['mean']);
});

function processModules(modules) {
  var packageModules = ['ngCookies', 'ngResource', 'ui.router', 'ui.select', 'ngSanitize', 'ngMaterial', 'ui.bootstrap', 'ngDialog', 'ui.bootstrap', 'moment-picker', 'darthwade.dwLoading'];
  var m;
  var mn;
  for (var index in modules) {
    m = modules[index];
    mn = 'mean.' + m.name;
    angular.module(mn, m.angularDependencies || []);
    packageModules.push(mn);
  }

  var req = require.context('./packages', true, /\/public\/(?!tests|assets|views)(.*)\.js$/);
  req.keys().map(req);
  req = require.context('./node_modules', true, /\/meanio-(.*)\/public\/(?!tests|assets|views)(.*)\.js$/);
  req.keys().map(req);

  var BLW = angular.module('mean', packageModules)
    .constant('_', window._);
  require('./constants/constant');
  require('./commonUtil/commonUtil');
  require('./commonUtil/onlyDigit');
}

jQuery.ajax('/_getModules', {
  dataType: 'json',
  async: false,
  success: processModules
});



// WEBPACK FOOTER //
// ./app.js